import axios from 'axios'
import rg4js from 'raygun4js'

const {
  VUE_APP_DEFAULT_PHONE_NUMBER,
  VUE_APP_DEFAULT_GUID,
  VUE_APP_DEFAULT_CAMPAIGN_NAME,
  VUE_APP_CAMPAIGN_SERVICE_PROXY_URL,
  VUE_APP_APP_NAME
} = process.env

export const state = {
  micPhoneNumber: VUE_APP_DEFAULT_PHONE_NUMBER,
  GUID: VUE_APP_DEFAULT_GUID,
  campaignName: VUE_APP_DEFAULT_CAMPAIGN_NAME
}

export const getters = {
  micPhoneNumberFormatted (state) {
    const { micPhoneNumber } = state

    return `
      ${micPhoneNumber.slice(0, 4)}
      ${micPhoneNumber.slice(4, 7)}
      ${micPhoneNumber.slice(7)}
    `.trim()
  },

  GUID: state => state.GUID
}

export const mutations = {
  SET_CAMPAIGN (state, campaign) {
    Object.entries(campaign).forEach(([key, value]) => {
      if (value) state[key] = value
    })
  }
}

export const actions = {
  fetchCampaign (context, { googleR: r, referrerURL, currentURL }) {
    return axios.post(VUE_APP_CAMPAIGN_SERVICE_PROXY_URL, {
      r,
      referrerURL,
      currentURL,
      appName: VUE_APP_APP_NAME
    })
      .then(({ data }) => {
        if (!data.campaign) return

        const {
          guid: GUID,
          campaign_phone_no: micPhoneNumber,
          campaign_name: campaignName
        } = data.campaign

        const number = context.state.micPhoneNumber === VUE_APP_DEFAULT_PHONE_NUMBER ? micPhoneNumber : context.state.micPhoneNumber

        context.commit('SET_CAMPAIGN', {
          GUID,
          micPhoneNumber: number,
          campaignName
        })
      })
      .catch(error => {
        if (error.message === 'Network Error') error.message += ': Campaign Service Proxy'
        rg4js('send', { error, customData: { requestedUrl: VUE_APP_CAMPAIGN_SERVICE_PROXY_URL } })
      })
  }
}
